import React from 'react';
import { Modal } from './Modal';

// Tauri WebView2에서는 window.confirm이 동작하지 않으므로(즉시 false 반환)
// 확인/취소가 필요한 곳은 이 컴포넌트를 사용한다.
interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  /** 선택적 체크박스 (예: 로그아웃 모달의 "로그아웃 후에도 알림 받기") */
  checkbox?: { label: string; checked: boolean; onChange: (checked: boolean) => void };
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmLabel = '확인',
  cancelLabel = '취소',
  danger = false,
  checkbox,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      size="sm"
      footer={
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
              danger
                ? 'bg-white border border-brand-600 text-brand-600 hover:bg-brand-50'
                : 'bg-brand-600 hover:bg-brand-700 text-white'
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      }
    >
      <p className="text-sm text-slate-600 whitespace-pre-line">{message}</p>
      {checkbox && (
        <label className="mt-3 flex items-center gap-2 text-sm text-slate-600 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={checkbox.checked}
            onChange={(e) => checkbox.onChange(e.target.checked)}
            className="w-4 h-4 rounded accent-brand-600"
          />
          {checkbox.label}
        </label>
      )}
    </Modal>
  );
};
